// SmartyAdd.jsx (Smarty Add/Update/Delete)

import React, { useEffect, useState } from "react";
import { useNavigate, Link, useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import Loader from "../../components/utils/Loader";
import useFetch from "../../hooks/useFetch";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCheckToSlot,
  faCopy,
  faFileVideo,
  faListCheck,
  faMicrochip,
  faMicrophone,
  faUpload,
} from "@fortawesome/free-solid-svg-icons";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import AILightComponent from "../../components/AILightComponent";
import SpeechInputComponent from "../../components/SpeechInputComponent";
import QRCode from "react-qr-code";
import { GenerateSCCode } from "../../components/GenerateThink5whysCode";
import UploadImage from "../../components/UploadImage";

const SmartyAdd = () => {
  const authState = useSelector((state) => state.authReducer);
  const navigate = useNavigate();
  const [fetchData, { loading }] = useFetch();
  const { itemId, ttype } = useParams();
  const mode = itemId === undefined ? "add" : "update";
  const [smartyItem, setSmartyItem] = useState(null);
  const [userId, setUserId] = useState(authState.user._id);
  const [userName, setUserName] = useState(authState.user.name);
  const [userCode, setUserCode] = useState(authState.user.think5whyscode);
  const [otherUserCode, setOtherUserCode] = useState(
    authState.user.think5whyscode
  );
  const [additionalDataEntry, setAdditionalDataEntry] = useState(false);
  const [isCheckedAISupport, setIsCheckedAISupport] = useState(false);
  const [showMicrophoneAlert, setShowMicrophoneAlert] = useState(false);
  const [showMapCapture, setShowMapCapture] = useState(false);
  const [showCloneData, setShowCloneData] = useState(false);
  const [showImageUpload, setShowImageUpload] = useState(false);
  const [showQRScanner, setShowQRScanner] = useState(false);
  const [showQRGenrator, setShowQRGenrator] = useState(false);
  const [showDetailForm, setShowDetailForm] = useState(false);
  const [showControls, setShowControls] = useState(false);
  const [countFormErrors, setCountFormErrors] = useState(0);
  const [formErrors, setFormErrors] = useState({});
  const [error, setError] = useState(null);
  const [startTime, setStartTime] = useState(false);
  const [isDiary, setIsDiary] = useState(false);
  const [autoSmartyCode, setAutoSmartyCode] = useState(GenerateSCCode());
  const [encryptedText, setEncryptedText] = useState("");
  const [decryptedText, setDecryptedText] = useState("");
  const isLoggedIn = authState?.isLoggedIn || false;
  const dispatch = useDispatch();
  const [showAdvanced, setShowAdvanced] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const handleLogout = () => {
    // dispatch(logout());
    navigate("/smarty");
  };

  const [formData, setFormData] = useState({
    user: userId,
    userCode: userCode,
    otherUserCode: otherUserCode,
    item: "",
    description: "",
    itemDate: new Date(),
    qty: 0,
    unit: "Pc",
    currency: "₹",
    amount: 0.0,
    pricePerUnit: 0.0,
    category: "",
    subcategory: "",
    quality: "",
    storageLocation: "",
    bestBefore: new Date(),
    expiryDate: new Date(),
    purchasedFrom: "",
    vendorType: "",
    vendorPlace: "",
    entryRemarks: "",
    finalRemarks: "",
    status: "Stock-In",
    // planToBuy: false,
    wasteQty: "",
    wasteAmount: "",
    wasteReason: "",
    responsiblePerson: "",
    rcaCode: "",    
    tags: "",
    isFlagged: false,
    isShared: false,
    pairCode: "",
    smartyItemCode: autoSmartyCode,
    smartyItemLinkCode: "",
    isActive: true,
    isDeleted: false,
    dateCreated: new Date(),
    createdBy: authState.user._id,
  });

  useEffect(() => {
    document.title = mode === "add" ? "Add" : "Update";
  }, [mode]);

  useEffect(() => {
    if (mode === "update") {
      const config = {
        url: `/smartyitems/getforupdate`,
        method: "post",
        headers: { Authorization: authState.token },
        data: { itemId: itemId },
      };
      fetchData(config, { showSuccessToast: false })
        .then((data) => {
          setSmartyItem(data.item);
          setFormData({
            user: data.item.user,                      
            userCode: data.item.userCode,
            otherUserCode: data.item.otherUserCode,
            item: data.item.item,
            description: data.item.description,
            itemDate: new Date(data.item.itemDate),
            qty: data.item.qty,
            unit: data.item.unit,
            currency: data.item.currency,
            amount: data.item.amount,
            pricePerUnit: data.item.pricePerUnit,
            category: data.item.category,
            subcategory: data.item.subcategory,
            quality: data.item.quality,
            storageLocation: data.item.storageLocation,
            bestBefore: new Date(data.item.bestBefore),
            expiryDate: new Date(data.item.expiryDate),
            purchasedFrom: data.item.purchasedFrom,
            vendorType: data.item.vendorType,
            vendorPlace: data.item.vendorPlace,
            entryRemarks: data.item.entryRemarks,
            finalRemarks: data.item.finalRemarks,
            status: data.item.status,                  
            wasteQty: data.item.wasteQty,              
            wasteAmount: data.item.wasteAmount,        
            wasteReason: data.item.wasteReason,
            responsiblePerson: data.item.responsiblePerson,
            rcaCode: data.item.rcaCode,
            tags: data.item.tags,
            isFlagged: data.item.isFlagged,
            isShared: data.item.isShared,
            pairCode: data.item.pairCode,
            smartyItemCode: data.item.smartyItemCode,
            smartyItemLinkCode: data.item.smartyItemLinkCode,
            isActive: data.item.isActive,
            isDeleted: data.item.isDeleted,
            dateCreated: new Date(data.item.dateCreated),
            createdBy: data.item.createdBy,
          });

        })
        .catch((error) => {
          console.error("Error fetching Smarty data:", error);
          setError("Error fetching Smarty data");
        });
    }
  }, [mode, authState, itemId, fetchData]);

  useEffect(() => {
    if (mode === "add" && ttype) {
      setFormData((prev) => ({ ...prev, purpose: ttype }));
    }
  }, [mode, ttype]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    if (type === "checkbox") {
      setFormData({ ...formData, [name]: checked });
    } else if (name === "qty" || name === "pricePerUnit") {
      handleQtyOrPriceChange(name, value);
    } else if (name === "amount") {
      setFormData({ ...formData, amount: value, amountManualOverride: true });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleStartDateChange = (date) => {
    const isoDate = date ? date.toISOString() : "";
    setStartTime(isoDate);
    setFormData((prevFormData) => ({
      ...prevFormData,
      startTime: isoDate,
    }));
  };

  const handleEncrypt = () => {
    const encrypted = noSecret.handleAesEncrypt(
      formData.description,
      formData.secretKey
    );
    setEncryptedText(encrypted);
  };

  const handleDecrypt = () => {
    const decrypted = noSecret.handleAesDecrypt(
      encryptedText,
      formData.secretKey
    );
    setDecryptedText(decrypted);
  };

  const handleFormSubmit = () => {
    if (!validateForm()) return;
    handleSubmit(formData);
  };

  const handleSubmit = (e) => {
    const error = validateForm(formData);
    setFormErrors(error);
    setCountFormErrors(Object.keys(error).length);

    if (Object.keys(error).length > 0) {
      setFormErrors(
        Object.keys(error).reduce((total, key) => {
          total[key] = error[key];
          return total;
        }, {})
      );
      return;
    }
    if (mode === "add") {
      const config = {
        url: "/smartyitems",
        method: "post",
        data: {
          formData: formData,
          user: authState.user._id,
          startTime: startTime,
        },
        headers: { Authorization: authState.token },
      };
      fetchData(config).then(() => {
        navigate("/smarty/list");
      });
    } else {
      const config = {
        url: `/smartyitems/${itemId}`,
        method: "put",
        data: formData,
        headers: { Authorization: authState.token },
      };

      fetchData(config)
        .then(() => {
          navigate("/smarty/list");
        })
        .catch((error) => {
          console.error("Error updating Smarty Item:", error);
          setError("Error updating Smarty Item");
        });
    }
  };

  const handleQtyOrPriceChange = (field, value) => {
    const newFormData = { ...formData, [field]: value };
    const qtyNum = parseFloat(newFormData.qty) || 0;
    const priceNum = parseFloat(newFormData.pricePerUnit) || 0;
    if (!newFormData.amountManualOverride) {
      newFormData.amount = qtyNum * priceNum;
    }
    setFormData(newFormData);
  };

  const handleAddlCheckboxChange = () =>
    setAdditionalDataEntry((prev) => !prev);

  const validateForm = () => {
    const errors = {};
    if (!formData.item.trim()) errors.item = "Item Title is required";
    if (!formData.category) errors.category = "Category is required";
    if (formData.qty < 0) errors.qty = "Quantity cannot be negative";
    if (formData.pricePerUnit < 0)
      errors.pricePerUnit = "Price per unit cannot be negative";
    if (formData.amount < 0) errors.amount = "Amount cannot be negative";
    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const fieldError = (field) => (
    <p
      className={`mt-1 text-blue-400 text-xs ${
        formErrors[field] ? "block" : "hidden"
      }`}
    >
      <i className="mr-2 fa-solid fa-circle-exclamation" />
      {formErrors[field]}
    </p>
  );

  const handleMicrophoneClick = () => {
    setShowMicrophoneAlert(true);
  };

  const handleDetailFormClick = () => {
    setShowDetailForm(true);
  };

 return (
  <div className="min-h-full bg-black text-white">
      {/* Header */}
      <header className="sticky top-0 z-50 bg-black border-b border-blue-800 px-4 py-2 flex items-center justify-between shadow-lg">
        <div className="flex flex-col">
          <div className="text-xl lg:text-2xl font-bold text-blue-400">
            🤓 Smarty Data
          </div>
          <div className="text-[10px] lg:text-lg text-yellow-200">
            Ghar Ka Data Scientist!
          </div>
        </div>

        <div className="hidden md:flex items-center gap-3">
          {isLoggedIn ? (
            <>
              <div className="text-xs text-blue-300">{userName}</div>
              <button
                onClick={() => navigate("/smarty")}
                className="w-10 p-2 mt-2 rounded-md bg-yellow-100 border border-blue-600 hover:bg-blue-700 transition"
                title="Home"
              >
                🔙
              </button>
            </>
          ) : (
            <>
              <button
                onClick={() => navigate("/login")}
                className="px-3 py-1 rounded-full border border-blue-700 text-sm text-blue-200 hover:bg-blue-900"
              >
                Login
              </button>
            </>
          )}
        </div>
      </header>

      {loading ? (
        <div>Loading...</div>
      ) : (
        <div className="text-sm px-4 pb-8">
          <div className="flex justify-center">
            <h2 className="mt-4 text-xl text-yellow-200">
              {mode === "add" ? "Add New Data" : "Edit Data"}
            </h2>
          </div>

          {/* Main Form */}
          <div className="mt-2 p-2 border border-gray-700 rounded-lg bg-black">
            <h3 className="text-yellow-300 font-semibold mb-2">Quick Entry</h3>
            <div className="text-sm">
              <label className="block mb-1">Smarty Entry Code: <span className="text-yellow-200">{formData.smartyItemCode}</span></label>
            </div>
            <div className="mb-2 text-sm">
              <label htmlFor="itemDate" className="block mb-1">
                Date*:
              </label>
              <DatePicker
                selected={formData.itemDate}
                onChange={(date) => setFormData({ ...formData, itemDate: date })}
                dateFormat="dd/MM/yyyy"
                id="itemDate"
                name="itemDate"
                className="w-40 h-8 px-2 py-1 border border-gray-400 rounded text-black bg-white text-sm"
              />
              {fieldError("itemDate")}
            </div>
            <div className="mb-2 text-sm">
              <label htmlFor="category" className="block mb-1">
                Category*:
              </label>
              <select
                name="category"
                id="category"
                value={formData.category}
                onChange={handleChange}
                className="mt-1 block w-64 h-10 border border-gray-400 rounded px-2 py-2 min-h-[40px] bg-white text-black text-sm"
              >
                <option value="">Select type</option>
                <optgroup label="Fresh & Perishables">
                  <option value="vegetables">Vegetables</option>
                  <option value="fruits_nuts">Fruits & Nuts</option>
                  <option value="non_veg">Meat / Fish / Eggs</option>
                  <option value="dairy">Dairy Products</option>
                  <option value="bakery">Bread & Bakery</option>
                </optgroup>
                <optgroup label="Grocery & Staples">
                  <option value="grocery">General Grocery</option>
                  <option value="spices">Spices & Masalas</option>
                  <option value="oils_ghee">Cooking Oils & Ghee</option>
                  <option value="pulses">Pulses / Lentils</option>
                  <option value="rice_wheat_grains">Rice / Wheat / Grains</option>
                </optgroup>
                <optgroup label="Snacks & Beverages">
                  <option value="snacks_sweets">Snacks & Sweets</option>
                  <option value="tea_coffee">Tea / Coffee</option>
                  <option value="juices_drinks">Juices & Beverages</option>
                </optgroup>
                <optgroup label="Health / Toiletries / Cleaning">
                  <option value="medicines">Medicines</option>
                  <option value="cleaning_supplies">Cleaning Supplies</option>
                  <option value="toiletries">Toiletries</option>
                  <option value="cosmetics">Cosmetics</option>
                </optgroup>
                <optgroup label="Baby & Pet Items">
                  <option value="baby_food">Baby Food & Formula</option>
                  <option value="pet_food">Pet Food</option>
                </optgroup>
                <optgroup label="Refrigerated & Packaged Foods">
                  <option value="frozen_foods">Frozen Foods</option>
                  <option value="ready_to_eat">Ready-to-Eat / Packaged Meals</option>
                  <option value="canned_items">Canned / Tinned Items</option>
                </optgroup>
                <optgroup label="Others">
                  <option value="others">Others</option>
                </optgroup>
              </select>
              {fieldError("category")}
            </div>

            <div className="mb-2 text-sm">
              <label htmlFor="item" className="block mb-1">
                Item *:
              </label>
              <input
                type="text"
                name="item"
                id="item"
                value={formData.item}
                placeholder="Enter the item..."
                maxLength={100}
                onChange={handleChange}
                className="w-40 border border-gray-400 rounded px-2 py-2 text-sm text-black"
              />
              {fieldError("item")}
            </div>
            <h3 className="text-yellow-300 font-semibold mt-4 mb-2">Quantity & Price</h3>
            <div className="flex flex-row gap-4">
              <div className="text-sm">
                <label htmlFor="qty" className="block mb-1">
                  Quantity:
                </label>
                <input
                  type="number"
                  name="qty"
                  id="qty"
                  value={formData.qty}
                  onChange={handleChange}
                  className="w-20 border border-gray-400 rounded px-2 py-2 text-sm text-black"
                />
              </div>
              <div className="text-sm">
                <label htmlFor="unit" className="block mb-1">
                  Unit:
                </label>
                <input
                  type="text"
                  name="unit"
                  id="unit"
                  value={formData.unit}
                  onChange={handleChange}
                  className="w-20 border border-gray-400 rounded px-2 py-2 text-sm text-black"
                />
              </div>
              <div className="text-sm">
                <label htmlFor="pricePerUnit" className="block mb-1">
                  Price/Unit:
                </label>
                <input
                  type="number"
                  name="pricePerUnit"
                  id="pricePerUnit"
                  value={formData.pricePerUnit}
                  onChange={handleChange}
                  className="w-20 border border-gray-400 rounded px-2 py-2 text-sm text-black"
                />
              </div>
              <div className="text-sm">
                <label htmlFor="amount" className="block mb-1">
                  Amount {formData.currency} :
                </label>
                <input
                  type="number"
                  name="amount"
                  id="amount"
                  value={formData.amount}
                  onChange={handleChange}
                  className="w-20 border border-gray-400 rounded px-2 py-2 text-sm text-black"
                />
                {fieldError("amount")}
              </div>
            </div>
            <div className="flex flex-row gap-4 mt-2">
              <label htmlFor="status" className="block mb-1">
                Status:
              </label>
              <select
                name="status"
                id="status"
                value={formData.status}
                onChange={handleChange}
                className="w-40 h-10 border border-gray-400 rounded px-2 py-2 text-sm bg-white text-black"
              >
                <option value="">Select Status</option>
                <option value="Stock-In">Stock-In</option>
                <option value="Planned">Planned</option>
                <option value="Consumed">Consumed</option>
                <option value="Wasted">Wasted</option>
                <option value="Donated">Donated</option>
              </select>
            </div>  
            <h3 className="text-yellow-300 font-semibold mt-4 mb-2">Expiry Details</h3>
            <div className="flex flex-row gap-4 mt-2">
              <div className="text-sm">
                <label htmlFor="bestBefore" className="block mb-1">
                  Best Before:
                </label>
                <DatePicker
                  selected={formData.bestBefore}
                  onChange={(date) => setFormData({ ...formData, bestBefore: date })}
                  dateFormat="dd/MM/yyyy"
                  id="bestBefore"
                  className="w-40 h-10 border border-gray-400 rounded text-black bg-white text-sm"
                />
              </div>
              <div className="text-sm">
                <label htmlFor="expiryDate" className="block mb-1">
                  Expiry Date:
                </label>
                <DatePicker
                  selected={formData.expiryDate}
                  onChange={(date) => setFormData({ ...formData, expiryDate: date })}
                  dateFormat="dd/MM/yyyy"
                  id="expiryDate"
                  className="w-40 h-10 border border-gray-400 rounded text-black bg-white text-sm"
                />
              </div>
            </div>                                       
            <div className="flex justify-start my-4">
              <button
                type="button"
                onClick={() => setShowAdvanced(!showAdvanced)}
                className="w-48 px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
              >
                {showAdvanced ? "Hide Other Entries" : "Show Other Entries"}
              </button>
            </div>

            {showAdvanced && (
              <div className="mt-4 p-3 border border-gray-600 rounded-lg bg-gray-900">
                {/* Category & Subcategory */}
                <h3 className="text-yellow-300 font-semibold mb-2">Category Details</h3>
                <div className="text-sm mb-2">
                  <label htmlFor="description" className="block mb-1">
                    Item Description:
                  </label>
                  <textarea
                    name="description"
                    id="description"
                    value={formData.description}
                    onChange={handleChange}
                    className="w-full border border-gray-400 px-2 py-1 bg-white text-black text-sm rounded max-h-[150px]"
                  />
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div className="mb-2 text-sm">
                    <label htmlFor="subcategory" className="block mb-1">
                      Sub-Category:
                    </label>
                    <input
                      type="text"
                      name="subcategory"
                      id="subcategory"
                      value={formData.subcategory}
                      placeholder="Enter subcategory..."
                      onChange={handleChange}
                      className="w-full border border-gray-400 rounded px-2 py-2 text-sm text-black"
                    />
                    {fieldError("subcategory")}
                  </div>
                </div>

                {/* Entry Remarks */}
                <h3 className="text-yellow-300 font-semibold mt-4 mb-2">Remarks & Description</h3>
                <div className="text-sm mb-2">
                  <label htmlFor="entryRemarks" className="block mb-1">
                    Entry Remarks:
                  </label>
                  <input
                    type="text"
                    name="entryRemarks"
                    id="entryRemarks"
                    value={formData.entryRemarks}
                    onChange={handleChange}
                    className="w-full border border-gray-400 rounded px-2 py-2 text-sm text-black"
                  />
                </div>

                {/* Quality & Storage */}
                <h3 className="text-yellow-300 font-semibold mt-4 mb-2">Quality & Storage</h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div className="text-sm">
                    <label htmlFor="quality" className="block mb-1">
                      Quality:
                    </label>
                    <input
                      type="text"
                      name="quality"
                      id="quality"
                      value={formData.quality}
                      onChange={handleChange}
                      className="w-full border border-gray-400 rounded px-2 py-2 text-sm text-black"
                    />
                  </div>
                  <div className="text-sm">
                    <label htmlFor="storageLocation" className="block mb-1">
                      Storage Location:
                    </label>
                    <input
                      type="text"
                      name="storageLocation"
                      id="storageLocation"
                      value={formData.storageLocation}
                      onChange={handleChange}
                      className="w-40 border border-gray-400 rounded px-2 py-2 text-sm text-black"
                    />
                  </div>
                </div>

                {/* Vendor Details */}
                <h3 className="text-yellow-300 font-semibold mt-4 mb-2">Vendor Details</h3>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                  <div className="text-sm">
                    <label htmlFor="purchasedFrom" className="block mb-1">
                      Purchased From:
                    </label>
                    <input
                      type="text"
                      name="purchasedFrom"
                      id="purchasedFrom"
                      value={formData.purchasedFrom}
                      onChange={handleChange}
                      className="w-full border border-gray-400 rounded px-2 py-2 text-sm text-black"
                    />
                  </div>
                  <div className="text-sm">
                    <label htmlFor="vendorType" className="block mb-1">
                      Vendor Type:
                    </label>
                    <select
                      name="vendorType"
                      id="vendorType"
                      value={formData.vendorType}
                      onChange={handleChange}
                      className="w-40 h-10 border border-gray-400 rounded px-2 py-2 text-sm text-black bg-white"
                    >
                      <option value="">Select Vendor Type</option>
                      <option value="Local Shop">Local Shop</option>
                      <option value="Online">Online</option>
                      <option value="Daily Market">Daily Market</option>
                      <option value="Home Supplier">Home Supplier</option>
                      <option value="Others">Others</option>
                    </select>
                  </div>
                  <div className="text-sm">
                    <label htmlFor="vendorPlace" className="block mb-1">
                      Vendor Place:
                    </label>
                    <input
                      type="text"
                      name="vendorPlace"
                      id="vendorPlace"
                      value={formData.vendorPlace}
                      onChange={handleChange}
                      className="w-40 border border-gray-400 rounded px-2 py-2 text-sm text-black"
                    />
                  </div>
                </div>

                {/* Waste Details */}
                <h3 className="text-yellow-300 font-semibold mt-4 mb-2">Waste Details</h3>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                  <div className="text-sm">
                    <label htmlFor="wasteQty" className="block mb-1">
                      Waste Qty:
                    </label>
                    <input
                      type="number"
                      name="wasteQty"
                      id="wasteQty"
                      value={formData.wasteQty}
                      onChange={handleChange}
                      className="w-full border border-gray-400 rounded px-2 py-2 text-sm text-black"
                    />
                  </div>
                  <div className="text-sm">
                    <label htmlFor="wasteAmount" className="block mb-1">
                      Waste Amount:
                    </label>
                    <input
                      type="number"
                      name="wasteAmount"
                      id="wasteAmount"
                      value={formData.wasteAmount}
                      onChange={handleChange}
                      className="w-20 border border-gray-400 rounded px-2 py-2 text-sm text-black"
                    />
                  </div>
                  <div className="text-sm">
                    <label htmlFor="wasteReason" className="block mb-1">
                      Waste Reason:
                    </label>
                    <select
                      name="wasteReason"
                      id="wasteReason"
                      value={formData.wasteReason}
                      onChange={handleChange}
                      className="w-32 h-10 border border-gray-400 rounded px-2 py-2 text-sm bg-white text-black"
                    >
                      <option value="">Select Reason</option>
                      <option value="Expired">Expired</option>
                      <option value="Damaged">Damaged</option>
                      <option value="Spoiled">Spoiled</option>
                      <option value="Overcooked">Overcooked</option>
                      <option value="Dropped">Dropped</option>
                      <option value="Other">Other</option>
                    </select>
                  </div>
                </div>

                <div className="text-sm mt-3">
                  <label htmlFor="responsiblePerson" className="block mb-1">
                    Responsible Person:
                  </label>
                  <input
                    type="text"
                    name="responsiblePerson"
                    id="responsiblePerson"
                    value={formData.responsiblePerson}
                    onChange={handleChange}
                    className="w-40 border border-gray-400 rounded px-2 py-2 text-sm text-black"
                  />
                </div>

                {/* ───── Additional Codes ───── */}
                <h3 className="text-yellow-300 font-semibold mt-4 mb-2">Additional Codes</h3>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                  {/* <div className="text-sm">
                    <label htmlFor="otherUserCode" className="block mb-1">
                      Other User Code:
                    </label>
                    <input
                      type="text"
                      name="otherUserCode"
                      id="otherUserCode"
                      value={formData.otherUserCode}
                      onChange={handleChange}
                      className="w-40 border border-gray-400 rounded px-2 py-2 text-sm text-black"
                    />
                  </div> */}
                  <div className="text-sm flex items-center">
                    <input
                      type="checkbox"
                      name="isShared"
                      id="isShared"
                      checked={formData.isShared}
                      onChange={(e) => setFormData({ ...formData, isShared: e.target.checked })}
                      className="mr-2"
                    />
                    <label htmlFor="isShared">Shared</label>
                  </div>                  
                  <div className="text-sm">
                    <label htmlFor="pairCode" className="block mb-1">
                      Shared Pair ThinkWhysCode:
                    </label>
                    <input
                      type="text"
                      name="pairCode"
                      id="pairCode"
                      value={formData.pairCode}
                      onChange={handleChange}
                      className="w-24 border border-gray-400 rounded px-2 py-2 text-sm text-black"
                    />
                  </div>
                  <div className="text-sm">
                    <label htmlFor="rcaCode" className="block mb-1">
                      Root Cause Analysis Code:
                    </label>
                    <input
                      type="text"
                      name="rcaCode"
                      id="rcaCode"
                      value={formData.rcaCode}
                      onChange={handleChange}
                      className="w-24 border border-gray-400 rounded px-2 py-2 text-sm text-black"
                    />
                  </div>
                  <div className="text-sm">
                    <label htmlFor="smartyItemLinkCode" className="block mb-1">
                      Related Smarty Item Code:
                    </label>
                    <input
                      type="text"
                      name="smartyItemLinkCode"
                      id="smartyItemLinkCode"
                      value={formData.smartyItemLinkCode}
                      onChange={handleChange}
                      className="w-24 border border-gray-400 rounded px-2 py-2 text-sm text-black"
                    />
                  </div>
                  <div className="text-sm md:col-span-2">
                    <label htmlFor="tags" className="block mb-1">
                      Tags (comma-separated):
                    </label>
                    <input
                      type="text"
                      name="tags"
                      id="tags"
                      value={formData.tags}
                      placeholder="e.g., organic, urgent"
                      onChange={handleChange}
                      className="w-full border border-gray-400 rounded px-2 py-2 text-sm text-black"
                    />
                  </div>
                </div>
               
                <div className="grid grid-cols-1 md:grid-cols-5 gap-4 mt-2">
                  <div className="text-sm flex items-center">
                    <input
                      type="checkbox"
                      name="isFlagged"
                      id="isFlagged"
                      checked={formData.isFlagged}
                      onChange={(e) => setFormData({ ...formData, isFlagged: e.target.checked })}
                      className="mr-2"
                    />
                    <label htmlFor="isFlagged">Flagged</label>
                  </div>
                 
                  <div className="text-sm flex items-center">
                    <input
                      type="checkbox"
                      name="isActive"
                      id="isActive"
                      checked={formData.isActive}
                      onChange={(e) => setFormData({ ...formData, isActive: e.target.checked })}
                      className="mr-2"
                    />
                    <label htmlFor="isActive">Active</label>
                  </div>
                  <div className="text-sm flex items-center">
                    <input
                      type="checkbox"
                      name="isDeleted"
                      id="isDeleted"
                      checked={formData.isDeleted}
                      onChange={(e) => setFormData({ ...formData, isDeleted: e.target.checked })}
                      className="mr-2"
                    />
                    <label htmlFor="isDeleted">Deleted</label>
                  </div>
                </div>
                <div className="text-sm mb-2">
                  <label htmlFor="finalRemarks" className="block mb-1">
                    Final Remarks:
                  </label>
                  <input
                    type="text"
                    name="finalRemarks"
                    id="finalRemarks"
                    value={formData.finalRemarks}
                    onChange={handleChange}
                    className="w-full border border-gray-400 rounded px-2 py-2 text-sm text-black"
                  />
                </div>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                  <label className="block text-sm mb-1 text-gray-400">User Code: {formData.userCode}</label>
                  <label className="block text-sm mb-1 text-gray-400">Date Created: {formData.dateCreated.toLocaleDateString()}</label>
                </div>
              </div>
            )}

            <div className="flex justify-start gap-4 mt-4 border border-gray-400 p-2">
              <button
                className="bg-green-800 text-white px-4 py-2 w-24 font-medium hover:bg-primary-dark rounded disabled:opacity-50"
                onClick={handleFormSubmit}
                disabled={formData.isUpdateLock && mode === "update"}
              >
                {mode === "add" ? "Save" : "Update"}
              </button>

              <button
                className="bg-red-500 text-white px-4 py-2 w-24 font-medium rounded hover:bg-red-600"
                onClick={() => navigate("/smarty/list")}
              >
                Cancel
              </button>
            </div>

            {/* Error display */}
            {Object.keys(formErrors).length > 0 && (
              <div className="text-red-300 mt-2 text-xs">
                {Object.keys(formErrors).map((key) => (
                  <div key={key}>{formErrors[key]}</div>
                ))}
              </div>
            )}
          </div>
          {/* Footer */}
          <footer className="bg-[#2a0f2f] border-t border-blue-800 text-blue-300 py-4 mt-8">
            <div className="max-w-6xl mx-auto px-3 flex flex-col md:flex-row items-center justify-between gap-3">
              <div className="text-xs lg:text-sm">
                © 2025 Think5Whys Global DeepTech Solutions. All rights reserved.
              </div>
              <div className="flex flex-wrap gap-4 text-xs lg:text-sm">
                <Link to="/about-us" className="text-white hover:text-blue-400">
                  About
                </Link>
                <Link to="/privacy-policy" className="text-white hover:text-blue-400">
                  Privacy Policy
                </Link>
                <Link to="/terms-of-use" className="text-white hover:text-blue-400">
                  Terms of Use
                </Link>
                <Link to="/contact-us" className="text-white hover:text-blue-400">
                  Contact
                </Link>
              </div>
            </div>
          </footer>
        </div>
      )}
    </div>
  );
};

export default SmartyAdd;
